import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  hint?: string;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}
export function Input({
  label,
  error,
  hint,
  leftIcon,
  rightIcon,
  className = '',
  id,
  ...props
}: InputProps) {
  const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');
  return <div className="w-full" data-id="element-592">
      {label && <label htmlFor={inputId} className="block text-sm font-medium text-[#B0B0B0] mb-1.5" data-id="element-593">
          {label}
        </label>}
      <div className="relative" data-id="element-594">
        {leftIcon && <div className="absolute left-3 top-1/2 -translate-y-1/2 text-[#666666]" data-id="element-595">
            {leftIcon}
          </div>}
        <input id={inputId} className={`w-full bg-[#1A1A1A] border rounded-lg px-4 py-2.5 text-white placeholder-[#666666] transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-0 ${error ? 'border-[#EF4444] focus:ring-[#EF4444]/30' : 'border-[#2A2A2A] focus:border-[#C8A84E] focus:ring-[#C8A84E]/20'} ${leftIcon ? 'pl-10' : ''} ${rightIcon ? 'pr-10' : ''} ${className}`} {...props} data-id="element-596" />
        {rightIcon && <div className="absolute right-3 top-1/2 -translate-y-1/2 text-[#666666]" data-id="element-597">
            {rightIcon}
          </div>}
      </div>
      {error && <p className="mt-1 text-sm text-[#EF4444]" data-id="element-598">{error}</p>}
      {hint && !error && <p className="mt-1 text-sm text-[#666666]" data-id="element-599">{hint}</p>}
    </div>;
}
interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}
export function Textarea({
  label,
  error,
  className = '',
  id,
  ...props
}: TextareaProps) {
  const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');
  return <div className="w-full" data-id="element-600">
      {label && <label htmlFor={inputId} className="block text-sm font-medium text-[#B0B0B0] mb-1.5" data-id="element-601">
          {label}
        </label>}
      <textarea id={inputId} className={`w-full bg-[#1A1A1A] border rounded-lg px-4 py-2.5 text-white placeholder-[#666666] transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-0 resize-none ${error ? 'border-[#EF4444] focus:ring-[#EF4444]/30' : 'border-[#2A2A2A] focus:border-[#C8A84E] focus:ring-[#C8A84E]/20'} ${className}`} {...props} data-id="element-602" />
      {error && <p className="mt-1 text-sm text-[#EF4444]" data-id="element-603">{error}</p>}
    </div>;
}
interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: {
    value: string;
    label: string;
  }[];
}
export function Select({
  label,
  error,
  options,
  className = '',
  id,
  ...props
}: SelectProps) {
  const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');
  return <div className="w-full" data-id="element-604">
      {label && <label htmlFor={inputId} className="block text-sm font-medium text-[#B0B0B0] mb-1.5" data-id="element-605">
          {label}
        </label>}
      <select id={inputId} className={`w-full bg-[#1A1A1A] border rounded-lg px-4 py-2.5 text-white transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-0 ${error ? 'border-[#EF4444] focus:ring-[#EF4444]/30' : 'border-[#2A2A2A] focus:border-[#C8A84E] focus:ring-[#C8A84E]/20'} ${className}`} {...props} data-id="element-606">
        {options.map(opt => <option key={opt.value} value={opt.value} data-id="element-607">
            {opt.label}
          </option>)}
      </select>
      {error && <p className="mt-1 text-sm text-[#EF4444]" data-id="element-608">{error}</p>}
    </div>;
}